export * as chatSettings from '@wix/auto_sdk_forms_chat-settings/meta';
export * as interactiveFormSessions from '@wix/auto_sdk_forms_interactive-form-sessions/meta';
export * as forms from '@wix/auto_sdk_forms_forms/meta';
export * as formSpamSubmissionReports from '@wix/auto_sdk_forms_form-spam-submission-reports/meta';
export * as submissions from '@wix/auto_sdk_forms_submissions/meta';
